export const Logo = ({ dark = false }) => (
    <a
        href="#"
        data-testid="logo-home-link"
        onClick={(e) => {
            e.preventDefault();
            if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
            else window.scrollTo({ top: 0, behavior: "smooth" });
        }}
        className="flex items-center"
        aria-label="ServiziAmici — torna su"
    >
        <span className="flex items-center gap-2.5">
            <img
                src="/logo-coin.png"
                alt="Servizi Amici — Accompagnamento & Assistenza"
                className={`shrink-0 rounded-full shadow-md shadow-ink/10 transition-transform duration-300 hover:scale-105 ${
                    dark ? "h-24 w-24 lg:h-36 lg:w-36" : "h-16 w-16 lg:h-24 lg:w-24"
                }`}
            />
            <span
                className={`font-hand text-3xl font-bold tracking-tight [-webkit-text-stroke:0.75px_currentColor] ${
                    dark ? "text-cream" : "text-ink"
                }`}
            >
                Servizi Amici
            </span>
        </span>
    </a>
);

export default Logo;
